import React from 'react';
import './CompletionGrid.css';

export default function CompletionGrid({ dailyCompletions, monthlyCompletions }) {
  // Get current date info
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // 1-12
  const currentDay = now.getDate();
  
  // Create month grid
  const monthDays = [];
  const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
  const completedDates = new Set(dailyCompletions || []);
  
  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const isCompleted = completedDates.has(dateStr);
    const isFuture = day > currentDay;
    
    monthDays.push({
      day,
      dateStr,
      isCompleted,
      isFuture
    });
  }
  
  // Create year grid
  const yearMonths = [];
  for (let month = 1; month <= 12; month++) {
    const ratio = monthlyCompletions?.[month] || 0;
    let status = 'none'; // 'none', 'partial', 'full'
    
    if (ratio >= 1.0) {
      status = 'full';
    } else if (ratio > 0.75) {
      status = 'partial';
    }
    
    const isFuture = month > currentMonth;
    
    yearMonths.push({
      month,
      ratio,
      status,
      isFuture
    });
  }
  
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  return (
    <div className="completion-grid-container">
      <div className="completion-grid-row">
        {/* Month Grid */}
        <div className="completion-grid-section">
          <div className="completion-grid-label">This Month</div>
          <div className="completion-grid-month">
            {monthDays.map(({ day, dateStr, isCompleted, isFuture }) => (
              <div
                key={day}
                className={`completion-grid-day ${isCompleted ? 'completed' : ''} ${isFuture ? 'future' : ''}`}
                title={`Day ${day}${isCompleted ? ' - Completed' : ' - Not completed'}`}
              />
            ))}
          </div>
        </div>
        
        {/* Year Grid */}
        <div className="completion-grid-section">
          <div className="completion-grid-label">This Year</div>
          <div className="completion-grid-year">
            {yearMonths.map(({ month, status, isFuture }) => (
              <div
                key={month}
                className={`completion-grid-month-box ${status} ${isFuture ? 'future' : ''}`}
                title={`${monthNames[month - 1]}${status === 'full' ? ' - 100%' : status === 'partial' ? ' - >75%' : ' - <75%'}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

